import { Component, Input, OnInit, Inject, Optional, AfterViewInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AuthService, ChangePasswordRequest, LoginResponse } from '../../../modules/auth';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from '@app/_helpers/utilities';
import { ErrorMatcher } from '@app/app.models';
import { StorageHelper, SELECTED_VENDOR, RECAPTCHA_REQUIRED, CAPTCHA_SITEKEY } from '@app/_helpers';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { StatusPopupComponent } from '../../../_shared/modules/status-popup/status-popup.component';
import { PASSWORD_CHANGED_TEXT } from '@shared/strings';
import { BUILD_DEALER } from '@app/_helpers/configuration';

@Component({
    selector: 'app-change-password-form',
    templateUrl: './change-password-form.component.html',
    styleUrls: ['./change-password-form.component.scss']
})
export class ChangePasswordFormComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() fromAuth: LoginResponse;
    @Input() affiliate: boolean;
    resetToken: string;
    matcher = new ErrorMatcher();
    regex: any;
    SELECTED_VENDOR = SELECTED_VENDOR;
    hide = [true, true];
    BUILD_DEALER = BUILD_DEALER;
    userinfo = this.authService.userInfo
    CAPTCHA_SITEKEY = CAPTCHA_SITEKEY;

    changePasswordForm = new UntypedFormGroup({
        oldPassword: new UntypedFormControl(null, [Validators.required]),
        newPassword: new UntypedFormControl(null),
        confirmNewPassword: new UntypedFormControl(null, [Validators.required]),
    }, { validators: [Utils.FormValidations.checkPasswords] });

    private captchaRef = null;
    RECAPTCHA_REQUIRED = RECAPTCHA_REQUIRED;

    constructor(
        private authService: AuthService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        public dialogRef: MatDialogRef<ChangePasswordFormComponent>,
        private dialog: MatDialog,
        @Optional() @Inject(MAT_DIALOG_DATA) public isDialog: boolean,

    ) {
        this.activatedRoute.queryParams.subscribe(params => {
            if (params.resetToken) {
                this.resetToken = params.resetToken;
                this.changePasswordForm.get('oldPassword').setValidators([]);
                this.changePasswordForm.get('oldPassword').updateValueAndValidity();
            }
        });
    }

    ngOnInit() {
        this.authService.getPasswordPolicy().subscribe(response => {
            this.regex = new RegExp(response.passwordPolicyRegularExpression);
            this.changePasswordForm.controls.newPassword.setValidators([Validators.required, Validators.pattern(this.regex)]);
            this.changePasswordForm.controls.newPassword.updateValueAndValidity();
        })
    }

    ngAfterViewInit(): void {
    
    }

    setCaptchaToken(captchaToken: string | null){
        if(captchaToken){
            this.authService.captchaToken = captchaToken;
        }
    }

    ngOnDestroy(): void {
    }



    changePassword() {
        if (this.showPreloginLayout && RECAPTCHA_REQUIRED && !this.authService.captchaToken) {
            return;
        }

        const rawValues = this.changePasswordForm.getRawValue();

        if (rawValues['newPassword'] === rawValues['confirmNewPassword']) {

            const req: ChangePasswordRequest = {
                newPassword: rawValues.newPassword,
                oldPassword: rawValues.oldPassword,
            };

            if (this.resetToken) {
                req.resetToken = this.resetToken;
            } else if (this.fromAuth) {
                req.accessToken = this.fromAuth.access;
            } else {
                req.accessToken = StorageHelper.userInfo.access;
            }

            this.authService.changePassword(req).then(pr => {
                pr.subscribe(res => {
                    this.openConfirmationDialogue();
                    if (this.fromAuth) {
                        this.authService.handleAuthResponse(this.fromAuth);
                    } else if (this.resetToken) {
                        this.router.navigateByUrl('/auth/login/');
                    }
                    this.closeDialog();
                })
            })
        }

        this.changePasswordForm.reset();
        this.changePasswordForm.get('oldPassword').markAsUntouched();
    }

    closeDialog() {
        this.dialogRef.close();
    }

    openConfirmationDialogue() {
        this.dialog.open(StatusPopupComponent, {
            data: {
                message: PASSWORD_CHANGED_TEXT
            },
            width: '550px',
            panelClass: 'dialog-rouded-edges',
            backdropClass: 'custom-backdrop'
        })
    }

    get showPreloginLayout() {
        return this.fromAuth || this.resetToken;
    }

}
